/* eslint-disable */
export default [
  {
    name: "Dashboard",
    link: "/",
    icon: "fas fa-tachometer-alt"
  },
  {
    name: "Motoristas",
    link: "/motoristas",
    icon: "fa fa-car",
    child: [
      {
        name: "Importar",
        link: "/motoristas/importar",
        icon: "fas fa-caret-right"
      },
      { name: "Listar Todos", link: "/motoristas", icon: "fas fa-caret-right" },
      {
        name: "Aguardando Pré-análise",
        link: "/motoristas/listar-aguardando-pre-analise",
        icon: "fas fa-caret-right"
      },
      {
        name: "Aguardando Validação",
        link: "/motoristas/listar-em-validacao",
        icon: "fas fa-caret-right"
      },
      {
        name: "Agendamento Solicitado",
        link: "/motoristas/listar-agendamento-solicitado",
        icon: "fas fa-caret-right"
      },
      {
        name: "Aguardando Agendamento",
        link: "/motoristas/listar-aguardando-agendamento",
        icon: "fas fa-caret-right"
      },
      {
        name: "Aguardando Ponto de Apoio",
        link: "/motoristas/listar-aguardando-ponto-apoio",
        icon: "fas fa-caret-right"
      },
      {
        name: "Aguardando Equipamento",
        link: "/motoristas/listar-aguardando-equipamento",
        icon: "fas fa-caret-right"
      },
      {
        name: "Agendamento Realizado",
        link: "/motoristas/listar-agendamento-realizado",
        icon: "fas fa-caret-right"
      },
      {
        name: "Ativos",
        link: "/motoristas/listar-ativos",
        icon: "fas fa-caret-right"
      },
      {
        name: "Reprovados",
        link: "/motoristas/listar-reprovados",
        icon: "fas fa-caret-right"
      },
      {
        name: "Excluídos",
        link: "/motoristas/listar-excluidos",
        icon: "fas fa-caret-right"
      },
      {
        name: "Outras Praças",
        link: "/motoristas/listar-outras-pracas",
        icon: "fas fa-caret-right"
      },
      {
        name: "Pendentes",
        link: "/motoristas/listar-pendentes",
        icon: "fas fa-caret-right"
      },
      {
        name: "Furto, Roubo ou Avaria",
        link: "/motoristas/listar-furto-roubo-avaria",
        icon: "fas fa-caret-right"
      },
      {
        name: "Cad. não Finali. - Pré-aprovado",
        link: "/motoristas/listar-cadastro-nao-finalizado-pre-aprovado",
        icon: "fas fa-caret-right"
      },
      {
        name: "Serasa",
        link: "/motoristas/listar-serasa",
        icon: "fas fa-caret-right"
      }
    ]
  },
  {
    name: "Agendamentos",
    link: "/agendamentos",
    icon: "far fa-clock",
    child: [
      {
        name: "Listar Todos",
        link: "/agendamentos",
        icon: "fas fa-caret-right"
      },
      {
        name: "Aguardando Agendamento",
        link: "/agendamentos/listar-aguardando-agendamento",
        icon: "fas fa-caret-right"
      },
      {
        name: "Agendados",
        link: "/agendamentos/listar-agendados",
        icon: "fas fa-caret-right"
      },
      {
        name: "Finalizados",
        link: "/agendamentos/listar-finalizados",
        icon: "fas fa-caret-right"
      },
      {
        name: "Não Executados",
        link: "/agendamentos/listar-nao-executados",
        icon: "fas fa-caret-right"
      },
      {
        name: "Cancelados",
        link: "/agendamentos/listar-cancelados",
        icon: "fas fa-caret-right"
      }
    ]
  },
  {
    name: "Equipamentos",
    link: "/equipamentos",
    icon: "fas fa-microchip",
    child: [
      {
        name: "Importar",
        link: "/equipamentos/importar",
        icon: "fas fa-caret-right"
      },
      {
        name: "Listar Todos",
        link: "/equipamentos",
        icon: "fas fa-caret-right"
      },
      {
        name: "Ativação",
        link: "/equipamentos/listar-cadastrados",
        icon: "fas fa-caret-right"
      },
      {
        name: "Disponível Ponto Apoio",
        link: "/equipamentos/listar-disponivel-ponto-apoio",
        icon: "fas fa-caret-right"
      },
      {
        name: "Em Utilização",
        link: "/equipamentos/listar-em-utilizacao",
        icon: "fas fa-caret-right"
      },
      {
        name: "Em Trânsito",
        link: "/equipamentos/listar-em-transito",
        icon: "fas fa-caret-right"
      },
      {
        name: "Inativos",
        link: "/equipamentos/listar-inativos",
        icon: "fas fa-caret-right"
      },
      {
        name: "Garantia",
        link: "/equipamentos/listar-garantia",
        icon: "fas fa-caret-right"
      },
      {
        name: "Perda/Roubo",
        link: "/equipamentos/listar-perda",
        icon: "fas fa-caret-right"
      },
      {
        name: "Manutenção",
        link: "/equipamentos/listar-manutencao",
        icon: "fas fa-caret-right"
      }
    ]
  },
  {
    name: "Distrib. Equipamentos",
    link: "/distribuicao-equipamentos",
    icon: "fas fa-shipping-fast",
    child: [
      {
        name: "Novo Lote",
        link: "/distribuicao-equipamentos/novo",
        icon: "fas fa-file"
      },
      {
        name: "Aguardando Envio",
        link: "/distribuicao-equipamentos/listar-aguardando-envio",
        icon: "fas fa-caret-right"
      },
      {
        name: "Saiu p/ entrega",
        link: "/distribuicao-equipamentos/listar-saiu-para-entrega",
        icon: "fas fa-caret-right"
      },
      {
        name: "Entrega Confirmada",
        link: "/distribuicao-equipamentos/listar-entrega-confirmada",
        icon: "fas fa-caret-right"
      }
    ]
  },
  {
    name: "Apuração Mensal",
    link: "/apuracao-mensal",
    icon: "fa fa-calendar-check-o",
    child: [
      {
        name: "Aguardando Validação",
        link: "/apuracao-mensal/listar-aguardando-validacao",
        icon: "fas fa-caret-right"
      },
      {
        name: "Apuradas",
        link: "/apuracao-mensal/listar-apuradas",
        icon: "fas fa-caret-right"
      },
      {
        name: "Rejeitadas",
        link: "/apuracao-mensal/listar-rejeitadas",
        icon: "fas fa-caret-right"
      },
      {
        name: "Avaliar performance",
        link: "/motoristas/performance",
        icon: "fas fa-caret-right"
      },
      {
        name: "Relatório Consolidado",
        link: "/apuracao-mensal/relatorio",
        icon: "fa fa-bar-chart"
      }
    ]
  },
  {
    name: "Ocorrências",
    link: "/ocorrencias",
    icon: "fas fa-info-circle",
    child: [
      {
        name: "Listar Todos",
        link: "/ocorrencias",
        icon: "fas fa-caret-right"
      },
      {
        name: "Aguardando Atendimento",
        link: "/ocorrencias/listar-aguardando-atendimento",
        icon: "fas fa-caret-right"
      },
      {
        name: "Em Atendimento",
        link: "/ocorrencias/listar-em-atendimento",
        icon: "fas fa-caret-right"
      },
      {
        name: "Pendentes",
        link: "/ocorrencias/listar-pendentes",
        icon: "fas fa-caret-right"
      },
      {
        name: "Concluídos",
        link: "/ocorrencias/listar-concluidos",
        icon: "fas fa-caret-right"
      },
      {
        name: "Cancelados",
        link: "/ocorrencias/listar-cancelados",
        icon: "fas fa-caret-right"
      }
    ]
  },
  {
    name: "Cadastros",
    link: "cadastros",
    icon: "fa fa-laptop",
    child: [
      {
        name: "Centro de Distribuição",
        link: "/centro-distribuicao",
        icon: "fas fa-caret-right"
      },
      {
        name: "Pontos de Apoio",
        link: "/ponto-apoio",
        icon: "fas fa-caret-right"
      },
      {
        name: "Usuários do Ponto de Apoio",
        link: "/usuarios-ponto-apoio",
        icon: "fas fa-caret-right"
      }
    ]
  },
  {
    name: "Mensagens",
    link: "mensagens",
    icon: "fas fa-comments",
    child: [
      {
        name: "Histórico",
        link: "/mensagens/historico",
        icon: "fas fa-caret-right"
      },
      {
        name: "Envio Manual",
        link: "/mensagens/envio-manual",
        icon: "fas fa-caret-right"
      }
    ]
  },
  {
    name: "Campanhas",
    link: "/campanhas/listar",
    icon: "fas fa-ad"
  },
  {
    name: "Configurações",
    link: "configuracoes",
    icon: "fa fa-cogs",
    child: [
      {
        name: "Apps",
        link: "/aplicativos",
        icon: "fas fa-caret-right"
      },
      {
        name: "Apps - Categorias",
        link: "/aplicativo-categorias",
        icon: "fas fa-caret-right"
      },
      {
        name: "Apps - Segmentos",
        link: "/aplicativo-segmentos",
        icon: "fas fa-caret-right"
      },
      {
        name: "Integração Auditoria",
        link: "/campanhas/integracao",
        icon: "fas fa-caret-right"
      },
      {
        name: "Motivos Pendência",
        link: "/motorista-pendencia-motivo",
        icon: "fas fa-exclamation"
      },
      {
        name: "Motivos Ocorrência",
        link: "/ocorrencia-motivo",
        icon: "far fa-file-alt"
      },
      {
        name: "Motivos de Não Instalação",
        link: "/servico-motivo",
        icon: "fas fa-comment-slash"
      },
      {
        name: "Tipos de Serviço",
        link: "/servico-tipo",
        icon: "fab fa-steam-square"
      },
      {
        name: "Envio de Mensagens",
        link: "/mensagem-config",
        icon: "fas fa-comment"
      },
      {
        name: "Usuários Backoffice",
        link: "/usuarios",
        icon: "fas fa-user-shield"
      },
      {
        name: "Parâmetros do Sistema",
        link: "/parametros",
        icon: "fas fa-cubes"
      }
    ]
  }
];



//////////////////
// WEBPACK FOOTER
// ./config/menus.js
// module id = null
// module chunks = 